export default __webpack_public_path__ + "static/media/paxel.65b9532e.png";